<div class="NgxEditor__Wrapper">
  @if (editor) {
    <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
    <ngx-editor
      [editor]="editor"
      [(ngModel)]="value"
      (ngModelChange)="onEditorChange($event)">
    </ngx-editor>
  }
</div>